<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('certificate_application')"
                        :isNewButton="checkPermission('certificateapplication_store')"
                        :isColumns="true"
                        :is-import-button="checkPermission('certificateapplication_excelimport')"
                        @import-button-click="handleOpenImportModal"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('certificate_application')"
                              :isNewButton="checkPermission('certificateapplication_store')"
                              :isColumns="true"
                              :is-import-button="checkPermission('certificateapplication_excelimport')"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :exportExcel="checkPermission('certificateapplication_excelexport')" @exportExcel="exportExcel"
            >
                <b-row>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('unit')">
                            <CertificateCenters v-model="datatable.queryParams.filter.certificate_center_code"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('certificate')">
                            <certificate-center-certificate-selectbox
                            v-model="datatable.queryParams.filter.certificate_id"
                        />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('certificate_persons')">
                            <certificate-person-selectbox v-model="datatable.queryParams.filter.certificate_person_id"/>
                        </b-form-group>
                    </b-col>

                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('status')">
                            <status-selectbox v-model="datatable.queryParams.filter.status"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('ebys_status')">
                            <multi-selectbox :allow-empty="true" :multiple="false"
                                             :options="ebysStatusOptions"
                                             v-model="datatable.queryParams.filter.ebys_status"></multi-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4" md="4">
                        <b-form-group :label="$t('certificate_date_between')" class="mb-0">
                            <v-date-picker v-model="localDateFilter" is-range >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 mr-1">
                                                <input :value="inputValue.start" v-on="inputEvents.start" :placeholder="$t('start_date')" class="form-control" />
                                            </b-form-group>
                                        </div>
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 ml-1">
                                                <input :value="inputValue.end" v-on="inputEvents.end" :placeholder="$t('end_date')" class="form-control" />
                                            </b-form-group>
                                        </div>
                                    </div>
                                </template>
                            </v-date-picker>
                        </b-form-group>
                    </b-col>

                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="showModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()" v-if="checkPermission('certificateapplication_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('certificateapplication_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('certificateapplication_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
            <CommonModal ref="importModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
                <template v-slot:CommonModalTitle>
                    {{ $t('import').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <ImportExcel v-if="formProcess==='importModal'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import CertificatePersonSelectbox from '@/components/interactive-fields/CertificatePersonSelectbox'
    import CertificateCenterCertificateSelectbox from '@/components/interactive-fields/CertificateCenterCertificateSelectbox'
    import StatusSelectbox from '@/components/interactive-fields/StatusSelectbox';

    //Page
    import CreateForm from './CreateForm'
    import ShowForm from './ShowForm'
    import UpdateForm from './UpdateForm'

    //Service
    import CertificateApplicationService from '@/services/CertificateApplicationService';
    import { EventBus } from '@/main'


    //Other
    import qs from 'qs';
    import CertificateCenters from "@/components/interactive-fields/CertificateCenters.vue";
    import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate.vue";
    import ProcessingButton from "@/components/elements/ProcessingButton.vue";
    import ImportExcel from "./ImportExcel.vue"
    import moment from "moment";

    export default {
        components: {
            ImportExcel,
            ProcessingButton,
            DownloadExcelTemplate,
            CertificateCenters,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            CertificatePersonSelectbox,
            CertificateCenterCertificateSelectbox,
            StatusSelectbox,

            CreateForm,
            ShowForm,
            UpdateForm,
        },
        metaInfo() {
            return {
                title: this.$t('certificate_application')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                disableWhenPrint: true,
                ebysStatusOptions: [
                    {value: 'waiting', text: this.$t('ebys_status_waiting')},
                    {value: 'ready', text: this.$t('ebys_status_ready')},
                ],
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'certificateapplication_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'certificateapplication_update',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadData();
                                    }
                                },
                                {
                                    text: this.$t('create_certificate'),
                                    class: 'ri-file-list-line',
                                    permission: 'certificateapplication_createcertificate',
                                    callback: (row) => {
                                        this.downloadForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t('ebys_send'),
                                    class: 'ri-send-plane-line',
                                    permission: 'certificateapplication_sendebys',
                                    callback: (row) => {
                                        this.sendToEbys(row.id)
                                    },
                                },
                                {
                                    text: this.$t('clear_ebys'),
                                    class: 'ri-delete-bin-line',
                                    permission: 'certificateapplication_clearebys',
                                    callback: (row) => {
                                        this.clearEbys(row.id)
                                    },
                                },

                                {
                                    text: this.$t('payment_info'),
                                    class: 'ri-money-dollar-circle-line',
                                    permission: 'customer_certificatepayments',
                                    callback: (row) => {
                                        this.$router.push('/customers/payments/certificate/' + row.person.number);
                                    }
                                },
                                {
                                    text: this.$t('download'),
                                    class: 'ri-download-line',
                                    permission: 'certificateapplication_download',
                                    callback: (row) => {
                                        this.download(row.id, row.signed_certificate)
                                    },
                                    show: (row) => {
                                        return row?.signed_certificate != null;
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'certificateapplication_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.$t('certificate'),
                            field: 'certificate_id',
                            hidden: false,
                            formatFn: (value, row) => {
                                return row.certificate.name
                            }
                        },
                        {
                            label: this.toUpperCase('certificate_persons'),
                            field: 'certificate_person_id',
                            hidden: false,
                            formatFn: (value, row) => {
                                return row.person.name + ' ' + row.person.surname
                            }
                        },
                        {
                            label: this.toUpperCase('price'),
                            field: 'price',
                            hidden: false,
                            formatFn: (value, row) => {
                                return this.currencyFormat(row.price)
                            }
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            hidden: false,
                            formatFn:(row)=>{
                                return row ==='a' ? this.$t('active') : this.$t('passive')
                            }
                        },
                        {
                            label: this.toUpperCase('ebys_status'),
                            field: 'ebys_status',
                            hidden: false,
                            formatFn: (value) => {
                                if (value === 'ready') return this.$t('ebys_status_ready');
                                if (value === 'waiting') return this.$t('ebys_status_waiting');
                                return value || '';
                            }
                        },
                        {
                            label: this.toUpperCase('created_at'),
                            field: 'created_at',
                            hidden: false,
                            formatFn: (value) => {
                                return this.toLocaleDate(value)
                            }
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                localDateFilter: {
                    start: null,
                    end: null
                },
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.localDateFilter=null
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;
                if (this.localDateFilter && this.localDateFilter.start && this.localDateFilter.end) {
                    this.datatable.queryParams.filter.created_at_greater_than = moment(this.localDateFilter.start).format("YYYY-MM-DD");
                    this.datatable.queryParams.filter.created_at_smaller_than = moment(this.localDateFilter.end).format("YYYY-MM-DD");
                }
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };
                return CertificateApplicationService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData() {
                this.formProcess = 'update';
                CertificateApplicationService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.deleteModal(() => {
                    CertificateApplicationService.deleteCertificateApplication(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t('api.' + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    });
                });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            downloadForm(id) {
                CertificateApplicationService.downloadCertificateApplication(id)
                .then((response) => {
                        let fileName = this.$t('certificate') + '.pdf'
                        EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: fileName});
                    })
                    .catch((error) => {
                        this.$toast.error(this.$t('api.' + error.response.data.message || error.message));
                    });
            },
            exportExcel() {
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                return CertificateApplicationService.exportExcel(config)
                    .then((response) => {
                        this._downloadFile(response, 'certificate_applications.xlsx')
                    })
                    .catch(err=>this.showErrors(err))
            },
            download(id, row) {
                CertificateApplicationService.download(id, row.uuid)
                    .then(response=>{
                        this._downloadFile(response, row.file_name)
                    }).catch(e => {
                        this.showErrors(e, null, true)
                    })

            },
            sendToEbys(id) {
                this.$swal.fire({
                    text: this.$t('ebys_send_statement'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        CertificateApplicationService.sendEbys(id).then((response) => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                        }).catch(e => {
                            this.$toast.error(this.$t('api.' + e.data.message));
                        })
                    }
                })
            },
            clearEbys(id) {
                this.$swal.fire({
                    text: this.$t('ebys_clear_statement'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        CertificateApplicationService.clearEbys(id).then((response) => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.getRows();
                        }).catch(e => {
                            this.$toast.error(this.$t('api.' + e.data.message));
                        })
                    }
                })
            },
            handleOpenImportModal(){
                this.formProcess = 'importModal'
                this.$refs.importModal.$refs.commonModal.show()
            },



        }
    }
</script>
